/**
 * Picks navbar tree for HeaderNav — Payload when available, static fallback otherwise.
 *
 * While a locale refetch is in flight, keep the last CMS tree (stale-while-revalidate)
 * so the nav does not flash back to static navbarLinks.
 *
 * @param {{
 *   staticLinks: unknown[],
 *   cmsLinks: unknown[],
 *   loading: boolean,
 *   error: string | null,
 *   isPayloadSource: boolean,
 * }} options
 * @returns {{ links: unknown[], isResolved: boolean }} `isResolved` is true when
 *   `links` came from Payload (already localized) — false for the static config
 *   (whose title/route/imgAlt are i18n keys needing `t()`).
 */
export function selectNavbarLinks({
  staticLinks,
  cmsLinks,
  loading,
  error,
  isPayloadSource,
}) {
  if (isPayloadSource && !error && cmsLinks.length > 0) {
    return { links: cmsLinks, isResolved: true };
  }

  return { links: staticLinks, isResolved: false };
}
